import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface SaveIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const SaveIcon = ({ className, ...props }: SaveIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.1719 2.25C16.9011 2.25008 17.6006 2.54001 18.1162 3.05566L20.9443 5.88379C21.46 6.39944 21.7499 7.09889 21.75 7.82812V19C21.75 20.5188 20.5188 21.75 19 21.75H5C3.48122 21.75 2.25 20.5188 2.25 19V5C2.25 3.48122 3.48122 2.25 5 2.25H16.1719ZM5 3.75C4.30964 3.75 3.75 4.30964 3.75 5V19C3.75 19.6904 4.30964 20.25 5 20.25H5.25V13.5996C5.25021 12.8543 5.85433 12.2502 6.59961 12.25H17.4004C18.1457 12.2502 18.7498 12.8543 18.75 13.5996V20.25H19C19.6904 20.25 20.25 19.6904 20.25 19V7.82812C20.2499 7.49671 20.1181 7.17869 19.8838 6.94434L17.0557 4.11621C16.9649 4.02547 16.8617 3.9499 16.75 3.8916V8.40039C16.7498 9.14567 16.1457 9.74979 15.4004 9.75H8.59961C7.85433 9.74979 7.25021 9.14567 7.25 8.40039V3.75H5ZM6.75 20.25H17.25V13.75H6.75V20.25ZM8.75 8.25H15.25V3.75H8.75V8.25Z"
      fill="currentColor"
    />
  </svg>
);

export default SaveIcon;
